import videojs from 'video.js';

export function createSubtitleButton(playerRef: any) {
  const Component = videojs.getComponent('SubtitlesButton');
  const subtitleButton = new Component(playerRef);
  playerRef.controlBar.addChild(subtitleButton);
}
